import { FormValues } from "./types";

export const names: Record<keyof FormValues, string> = {
  paymentMethodId: "paymentMethodId",
  centerPaymentMethodId: "centerPaymentMethodId",
  amount: "amount",
};
